/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseQueryOptions,
	UseQueryResult
} from '@tanstack/react-query';

import { customInstance } from '.././instance';
import type { ErrorType } from '.././instance';
import type {
	Case,
	CaseFeedResponse,
	CaseItemFeedResponse,
	CaseItemTagFeedResponse,
	CaseTimelineEntryListResponse,
	GetCaseTimelineParams,
	GetCasesParams,
	GetSyncCaseItemTagsParams,
	GetSyncCaseItemsParams,
	GetSyncCasesParams,
	GetSyncTagsParams,
	PraetoidError,
	SyncCaseFeedResponse,
	TagFeedResponse
} from '../models';

/**
 * Returns all cases with optional filtering, sorting, and pagination
 * @summary Get all cases
 */
export const getCases = (params?: GetCasesParams) => {
	return customInstance<CaseFeedResponse>({ url: `/cases`, method: 'GET', params });
};

export const getGetCasesQueryKey = (params?: GetCasesParams) => {
	return ['cases', ...(params ? [params] : [])] as const;
};

export const getGetCasesQueryOptions = <
	TData = Awaited<ReturnType<typeof getCases>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetCasesParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCases>>, TError, TData>>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetCasesQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getCases>>> = () => getCases(params);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getCases>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCasesQueryResult = NonNullable<Awaited<ReturnType<typeof getCases>>>;
export type GetCasesQueryError = ErrorType<PraetoidError>;

export function useGetCases<
	TData = Awaited<ReturnType<typeof getCases>>,
	TError = ErrorType<PraetoidError>
>(
	params: undefined | GetCasesParams,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCases>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getCases>>,
					TError,
					Awaited<ReturnType<typeof getCases>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCases<
	TData = Awaited<ReturnType<typeof getCases>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetCasesParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCases>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getCases>>,
					TError,
					Awaited<ReturnType<typeof getCases>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCases<
	TData = Awaited<ReturnType<typeof getCases>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetCasesParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCases>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get all cases
 */

export function useGetCases<
	TData = Awaited<ReturnType<typeof getCases>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetCasesParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCases>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetCasesQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns a thread for a case with all associated data including cases
 * @summary Get a thread for a case
 */
export const caseThread = (caseId: string) => {
	return customInstance<CaseFeedResponse>({ url: `/cases/${caseId}/thread`, method: 'GET' });
};

export const getCaseThreadQueryKey = (caseId: string) => {
	return ['cases', caseId, 'thread'] as const;
};

export const getCaseThreadQueryOptions = <
	TData = Awaited<ReturnType<typeof caseThread>>,
	TError = ErrorType<PraetoidError>
>(
	caseId: string,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof caseThread>>, TError, TData>>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getCaseThreadQueryKey(caseId);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof caseThread>>> = () => caseThread(caseId);

	return { queryKey, queryFn, enabled: !!caseId, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof caseThread>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CaseThreadQueryResult = NonNullable<Awaited<ReturnType<typeof caseThread>>>;
export type CaseThreadQueryError = ErrorType<PraetoidError>;

export function useCaseThread<
	TData = Awaited<ReturnType<typeof caseThread>>,
	TError = ErrorType<PraetoidError>
>(
	caseId: string,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof caseThread>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof caseThread>>,
					TError,
					Awaited<ReturnType<typeof caseThread>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCaseThread<
	TData = Awaited<ReturnType<typeof caseThread>>,
	TError = ErrorType<PraetoidError>
>(
	caseId: string,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof caseThread>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof caseThread>>,
					TError,
					Awaited<ReturnType<typeof caseThread>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCaseThread<
	TData = Awaited<ReturnType<typeof caseThread>>,
	TError = ErrorType<PraetoidError>
>(
	caseId: string,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof caseThread>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a thread for a case
 */

export function useCaseThread<
	TData = Awaited<ReturnType<typeof caseThread>>,
	TError = ErrorType<PraetoidError>
>(
	caseId: string,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof caseThread>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getCaseThreadQueryOptions(caseId, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns a single case with all associated data including actor and case items
 * @summary Get a specific case
 */
export const _case = (id: string) => {
	return customInstance<Case>({ url: `/cases/${id}`, method: 'GET' });
};

export const getCaseQueryKey = (id: string) => {
	return ['cases', id] as const;
};

export const getCaseQueryOptions = <
	TData = Awaited<ReturnType<typeof _case>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof _case>>, TError, TData>> }
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getCaseQueryKey(id);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof _case>>> = () => _case(id);

	return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof _case>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type _CaseQueryResult = NonNullable<Awaited<ReturnType<typeof _case>>>;
export type _CaseQueryError = ErrorType<PraetoidError>;

export function useCase<
	TData = Awaited<ReturnType<typeof _case>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof _case>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof _case>>,
					TError,
					Awaited<ReturnType<typeof _case>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCase<
	TData = Awaited<ReturnType<typeof _case>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof _case>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof _case>>,
					TError,
					Awaited<ReturnType<typeof _case>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCase<
	TData = Awaited<ReturnType<typeof _case>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof _case>>, TError, TData>> },
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a specific case
 */

export function useCase<
	TData = Awaited<ReturnType<typeof _case>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof _case>>, TError, TData>> },
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getCaseQueryOptions(id, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns all cases with optional filtering, sorting, and pagination
 * @summary Get all cases
 */
export const getSyncCases = (params?: GetSyncCasesParams) => {
	return customInstance<SyncCaseFeedResponse>({ url: `/sync/cases`, method: 'GET', params });
};

export const getGetSyncCasesQueryKey = (params?: GetSyncCasesParams) => {
	return ['sync', 'cases', ...(params ? [params] : [])] as const;
};

export const getGetSyncCasesQueryOptions = <
	TData = Awaited<ReturnType<typeof getSyncCases>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetSyncCasesParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncCases>>, TError, TData>>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetSyncCasesQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getSyncCases>>> = () =>
		getSyncCases(params);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getSyncCases>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSyncCasesQueryResult = NonNullable<Awaited<ReturnType<typeof getSyncCases>>>;
export type GetSyncCasesQueryError = ErrorType<PraetoidError>;

export function useGetSyncCases<
	TData = Awaited<ReturnType<typeof getSyncCases>>,
	TError = ErrorType<PraetoidError>
>(
	params: undefined | GetSyncCasesParams,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncCases>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getSyncCases>>,
					TError,
					Awaited<ReturnType<typeof getSyncCases>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSyncCases<
	TData = Awaited<ReturnType<typeof getSyncCases>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetSyncCasesParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncCases>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getSyncCases>>,
					TError,
					Awaited<ReturnType<typeof getSyncCases>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSyncCases<
	TData = Awaited<ReturnType<typeof getSyncCases>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetSyncCasesParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncCases>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get all cases
 */

export function useGetSyncCases<
	TData = Awaited<ReturnType<typeof getSyncCases>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetSyncCasesParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncCases>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetSyncCasesQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns all case items
 * @summary Get all case items
 */
export const getSyncCaseItems = (params?: GetSyncCaseItemsParams) => {
	return customInstance<CaseItemFeedResponse>({ url: `/sync/cases/items`, method: 'GET', params });
};

export const getGetSyncCaseItemsQueryKey = (params?: GetSyncCaseItemsParams) => {
	return ['sync', 'cases', 'items', ...(params ? [params] : [])] as const;
};

export const getGetSyncCaseItemsQueryOptions = <
	TData = Awaited<ReturnType<typeof getSyncCaseItems>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetSyncCaseItemsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncCaseItems>>, TError, TData>>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetSyncCaseItemsQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getSyncCaseItems>>> = () =>
		getSyncCaseItems(params);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getSyncCaseItems>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSyncCaseItemsQueryResult = NonNullable<Awaited<ReturnType<typeof getSyncCaseItems>>>;
export type GetSyncCaseItemsQueryError = ErrorType<PraetoidError>;

export function useGetSyncCaseItems<
	TData = Awaited<ReturnType<typeof getSyncCaseItems>>,
	TError = ErrorType<PraetoidError>
>(
	params: undefined | GetSyncCaseItemsParams,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncCaseItems>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getSyncCaseItems>>,
					TError,
					Awaited<ReturnType<typeof getSyncCaseItems>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSyncCaseItems<
	TData = Awaited<ReturnType<typeof getSyncCaseItems>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetSyncCaseItemsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncCaseItems>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getSyncCaseItems>>,
					TError,
					Awaited<ReturnType<typeof getSyncCaseItems>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSyncCaseItems<
	TData = Awaited<ReturnType<typeof getSyncCaseItems>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetSyncCaseItemsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncCaseItems>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get all case items
 */

export function useGetSyncCaseItems<
	TData = Awaited<ReturnType<typeof getSyncCaseItems>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetSyncCaseItemsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncCaseItems>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetSyncCaseItemsQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns all case item tags
 * @summary Get all case item tags
 */
export const getSyncCaseItemTags = (params?: GetSyncCaseItemTagsParams) => {
	return customInstance<CaseItemTagFeedResponse>({
		url: `/sync/cases/tags`,
		method: 'GET',
		params
	});
};

export const getGetSyncCaseItemTagsQueryKey = (params?: GetSyncCaseItemTagsParams) => {
	return ['sync', 'cases', 'tags', ...(params ? [params] : [])] as const;
};

export const getGetSyncCaseItemTagsQueryOptions = <
	TData = Awaited<ReturnType<typeof getSyncCaseItemTags>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetSyncCaseItemTagsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getSyncCaseItemTags>>, TError, TData>
		>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetSyncCaseItemTagsQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getSyncCaseItemTags>>> = () =>
		getSyncCaseItemTags(params);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getSyncCaseItemTags>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSyncCaseItemTagsQueryResult = NonNullable<
	Awaited<ReturnType<typeof getSyncCaseItemTags>>
>;
export type GetSyncCaseItemTagsQueryError = ErrorType<PraetoidError>;

export function useGetSyncCaseItemTags<
	TData = Awaited<ReturnType<typeof getSyncCaseItemTags>>,
	TError = ErrorType<PraetoidError>
>(
	params: undefined | GetSyncCaseItemTagsParams,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getSyncCaseItemTags>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getSyncCaseItemTags>>,
					TError,
					Awaited<ReturnType<typeof getSyncCaseItemTags>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSyncCaseItemTags<
	TData = Awaited<ReturnType<typeof getSyncCaseItemTags>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetSyncCaseItemTagsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getSyncCaseItemTags>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getSyncCaseItemTags>>,
					TError,
					Awaited<ReturnType<typeof getSyncCaseItemTags>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSyncCaseItemTags<
	TData = Awaited<ReturnType<typeof getSyncCaseItemTags>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetSyncCaseItemTagsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getSyncCaseItemTags>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get all case item tags
 */

export function useGetSyncCaseItemTags<
	TData = Awaited<ReturnType<typeof getSyncCaseItemTags>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetSyncCaseItemTagsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getSyncCaseItemTags>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetSyncCaseItemTagsQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns timeline entries for a specific case
 * @summary Get case timeline entries
 */
export const getCaseTimeline = (caseId: string, params?: GetCaseTimelineParams) => {
	return customInstance<CaseTimelineEntryListResponse>({
		url: `/sync/cases/${caseId}/timeline`,
		method: 'GET',
		params
	});
};

export const getGetCaseTimelineQueryKey = (caseId: string, params?: GetCaseTimelineParams) => {
	return ['sync', 'cases', caseId, 'timeline', ...(params ? [params] : [])] as const;
};

export const getGetCaseTimelineQueryOptions = <
	TData = Awaited<ReturnType<typeof getCaseTimeline>>,
	TError = ErrorType<PraetoidError>
>(
	caseId: string,
	params?: GetCaseTimelineParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseTimeline>>, TError, TData>>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetCaseTimelineQueryKey(caseId, params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getCaseTimeline>>> = () =>
		getCaseTimeline(caseId, params);

	return { queryKey, queryFn, enabled: !!caseId, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getCaseTimeline>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCaseTimelineQueryResult = NonNullable<Awaited<ReturnType<typeof getCaseTimeline>>>;
export type GetCaseTimelineQueryError = ErrorType<PraetoidError>;

export function useGetCaseTimeline<
	TData = Awaited<ReturnType<typeof getCaseTimeline>>,
	TError = ErrorType<PraetoidError>
>(
	caseId: string,
	params: undefined | GetCaseTimelineParams,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseTimeline>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getCaseTimeline>>,
					TError,
					Awaited<ReturnType<typeof getCaseTimeline>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCaseTimeline<
	TData = Awaited<ReturnType<typeof getCaseTimeline>>,
	TError = ErrorType<PraetoidError>
>(
	caseId: string,
	params?: GetCaseTimelineParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseTimeline>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getCaseTimeline>>,
					TError,
					Awaited<ReturnType<typeof getCaseTimeline>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCaseTimeline<
	TData = Awaited<ReturnType<typeof getCaseTimeline>>,
	TError = ErrorType<PraetoidError>
>(
	caseId: string,
	params?: GetCaseTimelineParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseTimeline>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get case timeline entries
 */

export function useGetCaseTimeline<
	TData = Awaited<ReturnType<typeof getCaseTimeline>>,
	TError = ErrorType<PraetoidError>
>(
	caseId: string,
	params?: GetCaseTimelineParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseTimeline>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetCaseTimelineQueryOptions(caseId, params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns all tags for categorizing case items
 * @summary Get all tags
 */
export const getSyncTags = (params?: GetSyncTagsParams) => {
	return customInstance<TagFeedResponse>({ url: `/sync/tags`, method: 'GET', params });
};

export const getGetSyncTagsQueryKey = (params?: GetSyncTagsParams) => {
	return ['sync', 'tags', ...(params ? [params] : [])] as const;
};

export const getGetSyncTagsQueryOptions = <
	TData = Awaited<ReturnType<typeof getSyncTags>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetSyncTagsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncTags>>, TError, TData>>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetSyncTagsQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getSyncTags>>> = () => getSyncTags(params);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getSyncTags>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSyncTagsQueryResult = NonNullable<Awaited<ReturnType<typeof getSyncTags>>>;
export type GetSyncTagsQueryError = ErrorType<PraetoidError>;

export function useGetSyncTags<
	TData = Awaited<ReturnType<typeof getSyncTags>>,
	TError = ErrorType<PraetoidError>
>(
	params: undefined | GetSyncTagsParams,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncTags>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getSyncTags>>,
					TError,
					Awaited<ReturnType<typeof getSyncTags>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSyncTags<
	TData = Awaited<ReturnType<typeof getSyncTags>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetSyncTagsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncTags>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getSyncTags>>,
					TError,
					Awaited<ReturnType<typeof getSyncTags>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSyncTags<
	TData = Awaited<ReturnType<typeof getSyncTags>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetSyncTagsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncTags>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get all tags
 */

export function useGetSyncTags<
	TData = Awaited<ReturnType<typeof getSyncTags>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetSyncTagsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncTags>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetSyncTagsQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}
